import { createSelector } from 'reselect'
import { getIntegrationMetadatasByName } from './metadata'

export function getSourceSettingIntegrations (state, workspaceSlug, sourceSettingSlug) {
  // Legacy sourceSlug's can contain dots
  const sourceSettingIntegrations = state.sourceSettingIntegrations || {}
  const request = sourceSettingIntegrations[`${workspaceSlug}-${sourceSettingSlug}`] || {}
  return request.data
}

export function getSourceSettingIntegrationsRequest (state, workspaceSlug, sourceSettingSlug) {
  // Legacy sourceSlug's can contain dots
  const sourceSettingIntegrations = state.sourceSettingIntegrations || {}
  const request = sourceSettingIntegrations[`${workspaceSlug}-${sourceSettingSlug}`] || {}
  const { isRequesting, didRequestFail, didRequest } = request
  return { isRequesting, didRequestFail, didRequest }
}

export const getSourceSettingIntegrationsWithMetadata = createSelector(
  [ getSourceSettingIntegrations, getIntegrationMetadatasByName ],
  (integrations = [], metadatas) => integrations
    .map(integration => ({
      ...integration,
      metadata: metadatas[integration.type]
    }))
    // Filter out integrations missing metadata.
    // This might happen if metadata has been deleted from our system.
    .filter(integration => integration.metadata)
)



// WEBPACK FOOTER //
// ./selectors/source-setting-integrations.js